// eslint-disable-next-line camelcase
export var en_us = {
    locale: "en_us",
    cancelText: "Cancel",
    confirmText: "OK",
    loading: "Loading",
    year: "",
    month: "",
    day: "",
    hour: "",
    minute: "",
    second: "",
    pleaseSelect: "Please select",
};
//# sourceMappingURL=en_us.js.map